
import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: 'Como funciona a garantia de 7 dias?',
      answer: 'Se você não ficar satisfeito com o produto, pode solicitar o reembolso total em até 7 dias após o recebimento. Basta entrar em contato conosco e processaremos a devolução sem complicações.'
    },
    {
      question: 'Qual o prazo de entrega?',
      answer: 'O prazo de entrega depende da data que você selecionar para o recebimento no ato da compra. Entregamos em até 24 horas. Clique para comprar e confira as datas disponíveis para receber.'
    },
    {
      question: 'Posso parcelar a compra?',
      answer: 'Sim! Você pode parcelar em até 12x no cartão de crédito com um pequeno acréscimo do parcelamento (Clique no botão de comprar para conferir os parcelamentos na próxima tela) ou pagar à vista no PIX, cartão de débito ou em Dinheiro. '
    },
    {
      question: 'As facas vêm afiadas?',
      answer: 'Sim, todas as facas vêm com o fio profissional de fábrica, prontas para uso. Recomendamos cuidado no manuseio e armazenamento seguro longe de crianças.'
    },
    {
      question: 'O produto tem nota fiscal?',
      answer: 'Sim, todos os produtos são enviados com nota fiscal. Somos uma empresa regularizada com CNPJ ativo.'
    },
    {
      question: 'Como entrar em contato com o suporte?',
      answer: 'Você pode entrar em contato através do WhatsApp +5584999495676. Nossa equipe está disponível de segunda a sábado, das 8h às 18h.'
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-800 mb-4">
            Perguntas Frequentes
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Tire suas dúvidas sobre o produto e processo de compra
          </p>
        </div>
        
        <div className="max-w-3xl mx-auto">
          {faqs.map((faq, index) => (
            <div key={index} className="mb-4">
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full bg-white rounded-lg p-6 text-left shadow-md hover:shadow-lg transition-shadow duration-300 cursor-pointer"
              >
                <div className="flex items-center justify-between">
                  <h3 className="text-lg font-semibold text-gray-800 pr-4">
                    {faq.question}
                  </h3>
                  <i className={`ri-arrow-${openIndex === index ? 'up' : 'down'}-s-line text-2xl text-gray-400 flex-shrink-0`}></i>
                </div>
                
                {openIndex === index && (
                  <div className="mt-4 pt-4 border-t border-gray-200">
                    <p className="text-gray-600 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                )}
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
